import { configureEnvironment } from "../../src/config/env";

export const obterImagemEmpresa = (empresa, ehMyPardini) => {
  if (ehMyPardini) {
    return {
      png: "/imgs/imagem_pesquisa_mypardini.png",
      webp: "",
      icon: configureEnvironment().PUBLIC_URL + "/favicon-mypardini.png"
    };
  }

  return {
    png: !empresa.imagemSvgBackground ? "/imgs/imagem_pesquisa.png" : `data:image/svg+xml;base64,${empresa.imagemSvgBackground}`,
    webp: !empresa.imagemSvgBackground ? "/imgs/imagem_pesquisa.webp" : `data:image/svg+xml;base64,${empresa.imagemSvgBackground}`,
    icon: !empresa.imagemSvgIcon ? configureEnvironment().PUBLIC_URL + "/favicon.png" : `data:image/svg+xml;base64,${empresa.imagemSvgIcon}`
  };
};
